import { __assign } from "tslib";
import _getStyle from './_getStyle';
import _css from './_css';
import _px2rem from './_px2rem';
export default (function (_ctx, styletronCSS) {
    // console.log('theme', _ctx.theme);
    var ctx = __assign(__assign({}, _ctx), { isRTL: _ctx.direction === 'rtl' });
    var css = _css.bind(null, ctx, styletronCSS);
    var getStyle = _getStyle.bind(null, ctx);
    var px2rem = _px2rem.bind(null, ctx);
    return __assign(__assign({}, ctx), { css: css, getStyle: getStyle, px2rem: px2rem });
});
